import React from "react";
import { Percent } from "lucide-react";

const CircularProgress = ({ value, color, label }) => {
  const clampedValue = Math.min(100, Math.max(0, value));
  const circumference = 2 * Math.PI * 45; // Circumference of circle with radius 45
  const strokeDashoffset = circumference - (clampedValue / 100) * circumference;

  return (
    <div className="relative w-[120px] h-[120px] flex items-center  justify-center">
      {/* SVG Circle */}
      <svg width="120" height="120" className="transform -rotate-90">
        {/* Background Circle */}
        <circle
          cx="60"
          cy="60"
          r="45"
          className="stroke-slate-700/30"
          strokeWidth="8"
          fill="none"
        ></circle>

        {/* Progress Circle */}
        <circle
          cx="60"
          cy="60"
          r="45"
          fill="transparent"
          stroke={color}
          strokeWidth="8"
          strokeDasharray={circumference}
          strokeDashoffset={strokeDashoffset}
          strokeLinecap="round"
        ></circle>
      </svg>

      {/* Centered Value */}
      <div className="absolute flex items-center justify-center text-center">
        <span
          className="text-2xl font-semibold text-slate-200"
          style={{ color }}
        >
          {value}%
        </span>
      </div>

      {/* Label */}
      <span className="absolute bottom-[-10%] text-xs text-slate-400">
        {label}
      </span>
    </div>
  );
};

// Horizontal bar component for OEE components
const HorizontalBar = ({ value, color, label }) => {
  return (
    <div className="flex items-center mb-2 w-full">
      <span className="w-36 text-xs font-semibold text-slate-400">{label}</span>
      <div className="relative w-full h-2 bg-slate-700  rounded-br-full">
        <div
          className="absolute top-0 left-0 h-2 rounded-br-full  "
          style={{
            width: `${value}%`,
            backgroundColor: color,
          }}
        ></div>
      </div>
      <span className="ml-2 text-xs font-semibold text-slate-300">
        {value}%
      </span>
    </div>
  );
};

const OEEMetrics = ({ oee, quality, performance, availability }) => {
  return (
    <div>
      {/* Main Content */}
      <div className="flex items-center justify-between">
        {/* Left Side: Circular Progress */}
        <div className="flex-shrink-0">
          <CircularProgress value={oee} color="#3b82f6" label="OEE" />
        </div>

        {/* Right Side: Horizontal Bars */}
        <div className="flex flex-col gap-3 w-2/3">
          <HorizontalBar value={quality} color="#10b981" label="Quality" />
          <HorizontalBar
            value={performance}
            color="#eab308"
            label="Performance"
          />
          <HorizontalBar
            value={availability}
            color="#F87171"
            label="Availability"
          />
        </div>
      </div>
    </div>
  );
};

export default OEEMetrics;
